import React, { useState } from 'react';
import { PrimaryButton, ErrorButton } from "../../UI";
import PrimaryModal from '../../UI/Modal/PrimaryModal';
import { useUserContext } from '../../../contexts/UserContext';
import { updateSpecificAdobeIoProduct } from '../../../utils/APIs';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const ActivateIntegration = ({ setActivateIntegration, id, setActionLoading, setConfirmModal, getAdobeData }) => {
    const { userData } = useUserContext();
    const { content } = useContentfulContext();

    const [error,setErrors]=useState({
        active:'',
        deactivate:'',
        delete:''
    })

    const handleUpdateProduct = async(id)=>{
        try {
            setActionLoading(true)
            const bodyData = { state: "active" };
            const result = await updateSpecificAdobeIoProduct(
                userData.token,
                userData.selectedOrganization.org_token,
                { productId: id, bodyData }
            );
            if (result) {
                setActivateIntegration(false);
                setConfirmModal({
                    active: true,
                    deactivate: false,
                    delete: false
                });
                setActionLoading(false)
                await getAdobeData()
            }
        } catch (error) {
            setErrors({ active: error?.message, deactivate: '', delete: '' });
            setActionLoading(false)
        }
    }


    return (
    <>
        {  <PrimaryModal title={content.ACTIVATE_INTEGRATION_MODAL.title} hideModal={setActivateIntegration}>
            <div className='p-6 space-y-6'>
                <p className="text-base leading-tight tracking-tight text-black mb-4">{content.ACTIVATE_INTEGRATION_MODAL.description_1}</p>
                <p className="text-base leading-tight tracking-tight text-red-500 mb-4">{error.active}</p>
                <div className="mb-4 space-x-4">
                    <ErrorButton handleClick={() => {
                        handleUpdateProduct(id)
                    }}>{content.ACTIVATE_INTEGRATION_MODAL.formLabels.deactivate_integration_cta}</ErrorButton>
                    <PrimaryButton handleClick={() => {
                        setActivateIntegration(false);
                    }}>{content.ACTIVATE_INTEGRATION_MODAL.formLabels.cancel_cta}</PrimaryButton>
                </div>
            </div>
        </PrimaryModal> }
    </>
    )
}

export default ActivateIntegration;